import type Immutable from 'immutable';

import TablePreferencesConstants from 'sharedreact/constants/TablePreferencesConstants';
import type ErrorData from 'sharedreact/data/ErrorData';
import type SortOrder from 'sharedreact/data/SortOrder';
import type TablePreferences from 'sharedreact/data/TablePreferences';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';
import ConnectionSupport from 'sharedreact/utils/ConnectionSupport';

// private functions
function fetchSuccess (values?: object): void {
  AppDispatcher.dispatch({
    actionType: TablePreferencesConstants.GET_SUCCESS,
    preferences: values,
    logLevel: 'debug'
  });
}

// exported functions
function setSelectedColumns (tableName: string, selectedColumns: Immutable.Set<string>): void {
  AppDispatcher.dispatch({
    actionType: TablePreferencesConstants.SET_SELECTED_COLUMNS,
    tableName: tableName,
    selectedColumns: selectedColumns,
    logLevel: 'trace'
  });
}

function setColumnWidths (tableName: string, columnWidths: Immutable.Map<string, string>): void {
  AppDispatcher.dispatch({
    actionType: TablePreferencesConstants.SET_COLUMN_WIDTHS,
    tableName: tableName,
    columnWidths: columnWidths,
    logLevel: 'trace'
  });
}

function setColumnOrder (tableName: string, columnOrder: Immutable.List<string>): void {
  AppDispatcher.dispatch({
    actionType: TablePreferencesConstants.SET_COLUMN_ORDER,
    tableName: tableName,
    columnOrder: columnOrder,
    logLevel: 'trace'
  });
}

function setTableSortOrder (tableName: string, sortOrder: SortOrder): void {
  AppDispatcher.dispatch({
    actionType: TablePreferencesConstants.SET_TABLE_SORTORDER,
    tableName: tableName,
    sortOrder: sortOrder,
    logLevel: 'trace'
  });
}

function save (tablePreferences: TablePreferences, onSuccess?: () => void, onFailure?: (error: ErrorData) => void): void {
  ConnectionSupport.post(
    'services/saveUserPreferences',
    { key: 'TablePreferences', values: tablePreferences },
    (data) => {
      if (onSuccess) {
        onSuccess();
      }
    },
    (error) => {
      console.log(error);
      if (onFailure) {
        onFailure(error);
      }
    },
    false
  );
}

function fetch (): void {
  ConnectionSupport.post(
    'services/getUserPreferences',
    { key: 'TablePreferences' },
    (data) => fetchSuccess(data.values),
    (error) => console.log(error),
    false
  );
}

export default {
  setSelectedColumns,
  setColumnWidths,
  setColumnOrder,
  setTableSortOrder,
  save,
  fetch
};
